import { callAPI } from "@/utils/httpService"

export const getSessionData = () => {
  return callAPI({ url: "session-metadata", method: "GET" }).then(
    (data) => data,
  )
}
